<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_TASK_UPDATE')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Sửa danh mục công việc</h1>
      <div style="float: right">
        <button class="btn btn-light" @click="cancelModal = true">Hủy bỏ</button>
        <button class="btn btn-success btn-primary ml-2" @click="editCalendar">Sửa</button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: auto overflow-y: auto">
      <div class="card-body px-20 row">
        <ValidationObserver class="w-100" ref="formEdit">
          <form class="col-md-6" @submit.prevent="editCalendar">
            <ValidationProvider rules="required" vid="wkGroupId" name="Nhóm công việc">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Nhóm công việc<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <Select2 v-model="detail.wkGroupId" :options="optionGroup"></Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|minMaxName_2" vid="taskName" name="Tên công việc">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên công việc<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="detail.taskName" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|inputLimit50" vid="taskCode" name="Mã công việc">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Mã công việc<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="detail.taskCode" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="maxReceipt_2" vid="note" name="Mô tả">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label">Mô tả</label>
                <div class="col-sm-8">
                  <input v-model="detail.note" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|regexNumber1" vid="level" name="Cấp độ">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Cấp độ<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="detail.level" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required|maxReceipt_3"
              vid="reviewTime"
              name="Thời gian đánh giá điểm"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Thời gian đánh giá điểm<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model="detail.reviewTime" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required|maxReceipt_3"
              vid="condition"
              name="Điều kiện đánh giá hoàn thành"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Điều kiện đánh giá hoàn thành<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model="detail.condition" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|regexNumber" vid="point" name="Điểm đánh giá">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Điểm đánh giá<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="detail.point" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <b-modal id="modal-scoped" v-model="showModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()" v-if="errorEdit"> Đóng </b-button>
        <b-button size="sm" variant="success" @click="backToList" v-else> Đóng </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="editModal">
      <template #modal-header="{ close }">
        <h5>Sửa danh mục công việc</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn sửa danh mục công việc này ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="confirmEdit"> Xác nhận </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="cancelModal">
      <template #modal-header="{ close }">
        <h5>Huỷ sửa danh mục công việc</h5>
        <b-button size="sm" class="btn-close" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn huỷ ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="backToList"> Xác nhận </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        id: this.$route.params.id,
        detail: {},
        msgNoti: '',
        iconNoti: '',
        showModal: false,
        errorEdit: false,
        optionGroup: [],
        editModal: false,
        cancelModal: false,
      }
    },
    created() {
      this.detailTask()
      this.groupList()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      // sửa nhóm cv
      async editCalendar() {
        const isSuccess = await this.$refs.formEdit.validate()
        if (!isSuccess) {
          return
        }
        this.editModal = true
      },
      async confirmEdit() {
        this.editModal = false
        try {
          const data = await CalendarAfsService.editCatCalendar(this.detail)
          if (data.success) {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Sửa danh mục công việc thành công'
          } else {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.errorEdit = true
          }
        } catch (error) {
          console.log(error)
        }
      },
      backToList() {
        this.$router.push('/cat-calendar-afs')
      },
      async detailTask() {
        try {
          const data = await CalendarAfsService.detailCatCalendar({
            id: this.id,
          })
          if (data.success) {
            this.detail = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
      async groupList() {
        try {
          const data = await CalendarAfsService.groupCalendar({
            page: 1,
            size: 1000,
          })
          if (data.success) {
            this.optionGroup = data.data.map(e => {
              return {
                id: e.id,
                text: e.groupName,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
